export default "__VITE_ASSET__7BzEj$4f__"